module.exports = __webpack_public_path__ + "img/new_35.fc89e41b.jpg";